import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { Subscription } from 'rxjs';
import { delay, startWith } from 'rxjs/operators';
import { KPI } from '../../../@core/api';
import { InvestmentsService, SpreadsheetColumnsInvestmentsService } from '../../../@core/utils';
import { ScopeService } from '../../../@core/utils/scope.service';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridInvestmentComponent } from '../ag-grid-investment/ag-grid-investment.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NbCardModule, NbButtonModule, NbTooltipModule, NbDialogService } from '@nebular/theme';
import { PreDownloadDialogComponent } from '../pre-download-dialog/pre-download-dialog.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-investments-spreadsheet',
    styleUrls: ['./investments-spreadsheet.component.scss'],
    templateUrl: './investments-spreadsheet.component.html',
    standalone: true,
    imports: [
      NbCardModule,
      NbButtonModule,
      NbTooltipModule,
      FontAwesomeModule,
      AgGridInvestmentComponent,
      TranslateModule,
      NgClass,
    ],
})
export class InvestmentsSpreadsheetComponent implements OnInit, OnDestroy {
  @Input() public currentScenario: KPI.InvestmentScenario;
  @Input() public investmentsListColumns: string[] = [];
  @Input() public investmentsListFilter: any;
  @Input() public applyPeriod: boolean = true;
  @Input() public quickFilter: boolean = false;
  @Input() public contextMenuLockButton: boolean = true;
  @Input() public isFidjiAct: boolean = false;
  @Input() public showAddButton: boolean = true;

  @ViewChild(AgGridInvestmentComponent) grid!: AgGridInvestmentComponent;

  public investments: KPI.MappedInvestment[] = [];
  public investmentScenarii: KPI.InvestmentScenario[] = [];

  private subscriptions: Subscription[] = [];
  public user: KPI.User;
  public energyEnabled: boolean = false;

  constructor(
    private investmentsService: InvestmentsService,
    private scope: ScopeService,
    private investmentsGridService: SpreadsheetColumnsInvestmentsService,
    private dialogService: NbDialogService,
  ) {
  }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.investmentsService.investmentsLoading$.pipe(
        startWith(false),
        delay(0),
      ).subscribe(),
      this.scope.user$.subscribe(user => {
        this.user = user;
        this.energyEnabled = !!user.can_access_energy;
      }),
    );
  }

  public exportInvestment(): void {
      const allColumns = this.grid.gridApi?.getColumns() || [];
      const columns = allColumns
        .filter(col => col.isVisible()) 
        .filter(col => {
          const colDef = col.getUserProvidedColDef();
          return !colDef.field?.startsWith('empty_') && 
                 colDef.field !== 'row_nb' && 
                 colDef.field !== 'invest_id' &&
                 colDef.field !== 'asset_id' &&
                 colDef.headerName !== ''; 
        })
        .map(col => {
          const colDef = col.getUserProvidedColDef();
          const { hide, ...colDefWithoutHide } = colDef;
          return colDefWithoutHide;
        })
      this.investmentsGridService.preExportInvestments(columns).subscribe((downloadOptions) => {
        this.dialogService.open(PreDownloadDialogComponent, {
          closeOnBackdropClick: false,
          context: {
            downloadOptions: downloadOptions,
            columns: columns,
            reportType: "inv"
          }
        })
      })
    }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
